<template>
    <div>
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Parent Event Dashboard</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete color="#0f2027" rounded v-model="selected_children" :items="children" label="Select Child" item-text="name" item-value="id" outlined dense></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete color="#0f2027" rounded v-model="event" :items="event_list" label="Select Event" item-text="name" item-value="id" outlined dense></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-btn class="button" @click="getDetails()">Proceed</v-btn>
                </v-col>
            </v-row>
            <v-row justify="center" v-if="learner_info!=''">
                <v-col cols="12" sm="12" md="12">
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Child Information</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </v-col>
                <v-col cols="12" sm="3" md="3"><strong>Registration No. :</strong>{{ learner_info[0].reg_no }}</v-col>
                <v-col cols="12" sm="3" md="3"><strong>Name :</strong>{{ learner_info[0].name }}</v-col>
                <v-col cols="12" sm="3" md="3"><strong>Standard :</strong>{{ learner_info[0].learner_std }}</v-col>
                <v-col cols="12" sm="3" md="3"><strong>Division :</strong>{{ learner_info[0].learner_div }}</v-col>
            </v-row>
            <v-row justify="center" v-if="event_data!=''">
                <v-col cols="12" sm="12" md="12">
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Event Information</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </v-col>
                <v-col cols="12" sm="3" md="3"><strong>Event Name :</strong>{{ event_data[0].name }}</v-col>
                <v-col cols="12" sm="3" md="3"><strong>From Date :</strong>{{ event_data[0].from_date_time }}</v-col>
                <v-col cols="12" sm="3" md="3"><strong>To Date :</strong>{{ event_data[0].end_date_time }}</v-col>
                <v-col cols="12" sm="3" md="3"><strong>Event Description :</strong>{{ event_data[0].description }}</v-col>
            </v-row>
            <v-row justify="center" v-if="parent_appointment_data!=''">
                <v-col cols="12" sm="12" md="12">
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Slot/Appointment Information</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <v-data-table :headers="headers" :items="parent_appointment_data" class="elevation-1 mytable">
                        <template v-slot:item.action="{ item }">
                            <div>
                                <v-tooltip top color="red" v-if="item.slot_booking==true">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn outlined rounded v-bind="attrs" v-on="on" color="red" x-small v-if="item.slot_booking==true" @click="cancelSlot(item)">Cancel Slot</v-btn>
                                   </template>
                                <span><strong>Booked Slot -</strong> {{item.event_name}} </span>
                            </v-tooltip>

                                <v-btn outlined rounded color="primary" x-small v-else @click="bookSlot(item.all_time_slot_data,item.booked_time_slot_data,item.inst_id)">Book Slot</v-btn>
                            </div>
                        </template>
                        <template v-slot:[`item.appointment_meeting_link`]="{ item }">
                            <span v-if="item.slot_booking==true">
                                <span v-if="item.appointment_meeting_link">
                                    <a :href="item.appointment_meeting_link" target="_blank">
                                    <v-icon color="primary">mdi mdi-link</v-icon></a>
                                </span>
                                <span v-else>
                                    <label>--</label>
                                </span>
                            </span>
                            </template>
                             <template v-slot:[`item.is_slot_booked`]="{ item }">
                                    <span v-if="item.is_slot_booked">
                                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                                    </span>
                                    <span v-else>
                                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                                    </span>
                                </template>
                            <template v-slot:[`item.slot_type`]="{ item }">
                                <span v-if="item.slot_booking==true">
                                    <span v-if="item.appointment_meeting_link">Online</span>
                                    <span v-else>Offline</span>
                                </span>
                            </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-dialog v-model="dailog_cancel" style="margin-top: 10%;" max-width="1200px">
                <v-card class="mx-auto">
                    <v-toolbar dark flat dense color="primary">
                        <v-toolbar-title>
                        <center>
                            <strong>Cancel Slot</strong>
                        </center>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <strong>Are you sure you want cancel this slot ???</strong>
                        <v-btn dark text @click="cancel_crs_slot()"><v-icon>mdi-delete</v-icon>Yes</v-btn>
                            <v-btn dark text @click="dailog_cancel = false"><v-icon>mdi-close</v-icon>NO</v-btn>
                    </v-toolbar>
                    <v-row class="box" justify="center" v-if="learner_info!=''">
                        <v-col class="toolbar" cols="12" sm="12" md="12">
                           Child Information
                        </v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Registration No. :</strong>{{ learner_info[0].reg_no }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Name :</strong>{{ learner_info[0].name }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Standard :</strong>{{ learner_info[0].learner_std }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Division :</strong>{{ learner_info[0].learner_div }}</v-col>
                    </v-row>
                    <v-row class="box" justify="center" v-if="event_data!=''">
                        <v-col  class="toolbar" cols="12" sm="12" md="12">
                           Event Information
                        </v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Event Name :</strong>{{ event_data[0].name }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>From Date :</strong>{{ event_data[0].from_date_time }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>To Date :</strong>{{ event_data[0].end_date_time }}</v-col>
                    </v-row>
                    <v-row class="box" justify="center" v-if="eventBooking_id!=null">
                        <v-col class="toolbar" cols="12" md="12" sm="12">
                            Booked Slot Details
                        </v-col>    
                        
                        <v-col cols="12" sm="4" md="4"><strong>Subject :</strong>{{ eventBooking_id.appointment_course }}</v-col>
                        <v-col cols="12" sm="4" md="4"><strong>Teacher :</strong>{{ eventBooking_id.appointment_inst }}</v-col>
                        <v-col cols="12" sm="4" md="4"><strong>Slot Name :</strong>{{ eventBooking_id.event_name }}</v-col>
                        <v-col cols="12" sm="4" md="4"><strong>From Date :</strong>{{ eventBooking_id.appointment_from_date_time }}</v-col>
                        <v-col cols="12" sm="4" md="4"><strong>To Date :</strong>{{ eventBooking_id.appointment_end_date_time }}</v-col>
                    </v-row>
                        <center>
                          <strong>Are you sure you want cancel this slot ???</strong>
                      </center>
                      <v-row justify="center">
                         <v-btn class="button" text @click="cancel_crs_slot()">Yes</v-btn>
                          <v-btn class="button" text @click="dailog_cancel = false">No</v-btn>
                      </v-row>
                        </v-card>
                    
            </v-dialog>
            <v-dialog v-model="dailog_book" style="margin-top: 10%;" max-width="1900px">
                <v-card class="mx-auto">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Slot Details</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark text @click="dailog_book = false"><v-icon>mdi-close</v-icon>Close</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <br />
                    <v-card-text>
                        <span v-if="all_time_slot_data!=''">
                        <v-toolbar v-if="all_time_slot_data!=''" dark flat dense color="primary">
                            <v-toolbar-title>Available Slot Details</v-toolbar-title>
                        </v-toolbar>
                        <br />
                        <v-data-table v-if="all_time_slot_data!=''" :headers="headers_available_slot" :items="all_time_slot_data" class="elevation-1 mytable">
                            <template v-slot:item.action="{ item }">
                                <div v-if="item.can_book_slot">
                                    <v-btn outlined rounded color="primary" x-small @click="book_crs_slot(inst_id,event_data[0],learner_info[0],item.ets_id,item)">Book Slot</v-btn>
                                </div>
                                 <div v-else>
                                    <b>Slot Booking Time Is Over...</b>
                                 </div>
                            </template>
                            <!-- <template v-slot:[`item.ets_meeting_link`]="{ item }">
                                <span v-if="item.ets_meeting_link">
                                    <a :href="item.ets_meeting_link" target="_blank">
                                    <v-icon  color="primary">mdi mdi-link</v-icon></a>
                                </span>
                                <span v-else>
                                    <label>--</label>
                                </span>
                            </template> -->
                            <template v-slot:item.slot_type="{ item }">
                                <span v-if="item.ets_meeting_link">Online</span>
                                <span v-else>Offline</span>
                            </template>
                        </v-data-table>
                    </span>
                        <v-row dense justify="center" v-else class="flash"><strong>No slots available for booking</strong></v-row>
                        <br />
                        <v-toolbar v-if="booked_time_slot_data!=''" flat dense dark color="primary">
                            <v-toolbar-title>Booked Slot Details</v-toolbar-title>
                        </v-toolbar>
                        <br />
                        <v-data-table v-if="booked_time_slot_data!=''" :headers="headers_book_slot" :items="booked_time_slot_data" class="elevation-1 mytable" dense> </v-data-table>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
        data: () => ({
            selected_children: "",
            children: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            search: "",
            event_list: [],
            event: null,
            parent_appointment_data: [],
            learner_info: [],
            event_data: [],
            all_time_slot_data: [],
            booked_time_slot_data: [],
            dailog_book: false,
            dailog_cancel: false,
            inst_id:null,
            eventBooking_id:null,
            headers: [
                {
                    text: "Sr. No.",
                    align: "left",
                    sortable: false,
                    value: "sr_no",
                },
                // {
                //     text: "Course",
                //     align: "left",
                //     sortable: false,
                //     value: "course",
                // },
                {
                    text: "Instructor",
                    align: "left",
                    sortable: false,
                    value: "inst",
                },
                {
                    text: "Is Slot Booked",
                    align: "left",
                    sortable: false,
                    value: "is_slot_booked",
                },
                {
                    text: "From Date And Time",
                    align: "left",
                    sortable: false,
                    value: "from_date_time",
                },
                {
                    text: "To Date And Time",
                    align: "left",
                    sortable: false,
                    value: "end_date_time",
                },
                {
                    text: "Meeting Link",
                    align: "left",
                    sortable: false,
                    value: "appointment_meeting_link",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
            headers_book_slot: [
                {
                    text: "Slot Name",
                    align: "left",
                    sortable: false,
                    value: "ets_name",
                },
                {
                    text: "From Date And Time",
                    align: "left",
                    sortable: false,
                    value: "from_date_time",
                },
                {
                    text: "To Date And Time",
                    align: "left",
                    sortable: false,
                    value: "end_date_time",
                },
            ],
            headers_available_slot: [
                {
                    text: "Slot Name",
                    align: "left",
                    sortable: false,
                    value: "ets_name",
                },
                {
                    text: "Meeting Type",
                    align: "left",
                    sortable: false,
                    value: "slot_type",
                },
                // {
                //     text: "Meeting Link",
                //     align: "left",
                //     sortable: false,
                //     value: "ets_meeting_link",
                // },
                {
                    text: "From Date And Time",
                    align: "left",
                    sortable: false,
                    value: "from_date_time",
                },
                {
                    text: "To Date And Time",
                    align: "left",
                    sortable: false,
                    value: "end_date_time",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
        }),

        methods: {
            async book_crs_slot(inst_id,event_data,learner_info,ets_id,ets_data){
                if (!confirm("Are you sure you want to book this slot: "+ ets_data.ets_name + " from " + ets_data.from_date_time + " to " + ets_data.end_date_time + "?")) return;
                const data = {
                    inst_id:inst_id,
                    event_data:event_data,
                    learner_info:learner_info,
                    ets_id:ets_id
                }
                try {
                    const res = await axios.post("/Appointment/bookSlot", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", " Slot Booked Successfully..."); // show snackbar on success
                       this.getDetails()
                       this.dailog_book = false;
                    } else if(res.data.flag == "No"){
                        this.showSnackbar("#4caf50", res.data.snackbar); // show snackbar on success
                        this.dailog_book = false;
                    }
                    else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    this.showSnackbar("#b71c1c", "Something went wrong!");
                } finally {
                }
            },
            cancelSlot(eventBooking_id){
                this.eventBooking_id = null
                this.eventBooking_id = eventBooking_id
                this.dailog_cancel = true
            },
            async cancel_crs_slot(){
                const data={
                    eventBooking_id : this.eventBooking_id.eventBooking_id
                }
                try {
                    const res = await axios.post("/Appointment/cancelSlot", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", " Slot Cancelled Successfully..."); // show snackbar on success
                       this.getDetails()
                       this.dailog_cancel = false;
                    }else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar); // show snackbar on success 
                    }
                    else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    this.showSnackbar("#b71c1c", "Something went wrong!");
                } finally {
                }
            },
            bookSlot(all_time_slot_data,booked_time_slot_data,inst_id) {
                this.inst_id=null,(this.all_time_slot_data = []), (this.booked_time_slot_data = []), (this.all_time_slot_data = all_time_slot_data), (this.booked_time_slot_data = booked_time_slot_data);
                this.inst_id = inst_id
                this.dailog_book = true;
            },
            async getDetails() {
                const data = {
                    child: this.selected_children,
                    event: this.event,
                };
                try {
                    const res = await axios.post("/Appointment/getEventInfo", data);
                    if (res.data.flag == "YES") {
                        this.parent_appointment_data = res.data.parent_appointment_data;
                        this.learner_info = res.data.learner_info;
                        this.event_data = res.data.event_data;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                    }                    
                    else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    this.showSnackbar("#b71c1c", "Something went wrong!");
                } finally {
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },

        mounted() {
            //alert("this.s3url::"+this.s3url)
            axios
                .post("/AccountingAndFees/getChildList")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((res.data.status = "SUCCESS")) {
                            this.children = res.data.learners;
                            this.event_list = res.data.event_list;
                        } else {
                            alert(res.data.status_reason);
                        }
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.loader = false;
                    //alert("done")
                });
        },
    };
</script>

<style scoped>
 .flash {
   animation-name: flash;
    animation-duration: 0.9s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: running;
}

@keyframes flash {
    from {color: red;}
    to {color: white;}
}
</style>
